module.exports = __webpack_public_path__ + "img/menu_comparison.c3c1afc6.svg";